import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './IntraOne.frontend.types'

@Injectable({ providedIn: 'root' })
export class IntraOne_receive_data_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { inputs_0550: { target_warehouse_name: string, target_location_name: string }, inputs_4011: { licensplate_field_to_update: string, warehouse_name: string } }): Promise<{ reason?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.inputs_0550)) {
      $missingRequiredInParams.push('\'inputs_0550\'');
    }
    if (isNil($inParams.inputs_4011)) {
      $missingRequiredInParams.push('\'inputs_4011\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/functions/receive_data_flow`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

